import { render, staticRenderFns } from "./TransferenciaStockDetalleComponent.vue?vue&type=template&id=48ad76da&"
import script from "./TransferenciaStockDetalleComponent.vue?vue&type=script&lang=js&"
export * from "./TransferenciaStockDetalleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports